import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EllipsisPipe } from './ellipsis.pipe';
import { FilterObjectsByPropertiesPipe } from './filterObjectsByProperties.pipe';
import { NumberSuffixPipe } from './numberSuffix.pipe';
import { TitleNamePipe } from './title-name.pipe';

@NgModule({
    declarations: [
        EllipsisPipe,
        NumberSuffixPipe,
        FilterObjectsByPropertiesPipe,
        TitleNamePipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        EllipsisPipe,
        NumberSuffixPipe,
        FilterObjectsByPropertiesPipe,
        TitleNamePipe
    ]
})
export class SharedPipeModule { }
